<template>
  <div class="landing">
    <header class="landing-nav">
      <a href="/" class="brand">
        <img :src="logo" alt="Kolkin" class="brand-logo" />
        <span class="brand-name">Kolkin</span>
      </a>
      <nav class="landing-links">
        <router-link :to="{ name: 'home' }" class="nav-link">Sign In</router-link>
      </nav>
    </header>

    <main class="hero">
      <div class="hero-content">
        <h1 class="hero-title">
          Our Software Ensures Every Patient Gets the Best Possible Outcome
        </h1>
        <p class="hero-sub">
          Kolkin SOS is the real-time collaboration tool for physician teams
        </p>
        <div class="hero-actions">
          <a href="https://www.soslist.org" class="btn-secondary">The SOS List</a>
        </div>
      </div>
      <div class="hero-graphic">
        <img :src="hero" alt="Kolkin platform" />
      </div>
    </main>

    <footer class="landing-foot">
      <span>&copy; {{ year }} Kolkin</span>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Landing",
  data() {
    return {
      logo: require("@/assets/img/kolkin-logo-black.png"),
      hero: require("@/assets/img/newgen-graphic.png"),
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.landing {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  color: #1a2330;
  background: #ffffff;
}

.landing-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 6vw;
  border-bottom: 1px solid #eef1f5;
}
.brand { display: flex; align-items: center; gap: 11px; text-decoration: none; }
.brand-logo { height: 38px; display: block; }
.brand-name {
  font-family: "Source-Sans-Pro", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 27px;
  font-weight: 600;
  color: #1a2330;
  letter-spacing: -0.01em;
  line-height: 1;
}
.landing-links { display: flex; align-items: center; gap: 28px; }
.nav-link {
  color: #41506a;
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
}
.nav-link:hover { color: #1a2330; }

.hero {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5vw;
  padding: 7vh 6vw;
  max-width: 1500px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}
.hero-content { flex: 1 1 480px; max-width: 680px; }
.hero-title {
  font-size: clamp(32px, 3.8vw, 58px);
  line-height: 1.1;
  font-weight: 800;
  margin: 0 0 18px;
  letter-spacing: -0.02em;
}
.hero-sub {
  font-size: 19px;
  line-height: 1.55;
  color: #5a6b85;
  margin: 0 0 30px;
}
.hero-actions { display: flex; flex-wrap: wrap; gap: 14px; }
.btn-secondary {
  background: #336699;
  color: white;
  text-decoration: none;
  font-weight: 700;
  padding: 13px 24px;
  border-radius: 10px;
  font-size: 16px;
}
.btn-secondary:hover { background: #2B5C8A }

.hero-graphic { flex: 1 1 520px; max-width: 820px; }
.hero-graphic img { width: 100%; height: auto; display: block; }

.landing-foot {
  padding: 22px 6vw;
  border-top: 1px solid #eef1f5;
  color: #8a97ab;
  font-size: 14px;
}

/* Give the headline room and enlarge the graphic on large screens */
@media (min-width: 1600px) {
  .hero { max-width: 1560px; gap: 64px; padding: 8vh 56px; }
  .hero-content { max-width: 760px; }
  .hero-title { font-size: 64px; }
  .hero-sub { font-size: 21px; }
  .hero-graphic { max-width: 940px; }
}

@media (max-width: 860px) {
  .hero { flex-direction: column-reverse; text-align: center; padding-top: 5vh; }
  .hero-actions { justify-content: center; }
  .landing-links { gap: 16px; }
}
</style>
